<template>
    <div class="d-flex mx-auto w-100 w-sm-75 w-xl-50 align-items-center bg-white my-12" style="width: 65vw;">
        <div class="form bg-white px-12 rounded-lg">
            <div class="card-body">
                <div class="text-center mb-24">
                    <img alt="Logo" class="h-80px" src="images/ybd_b2b.png"/>
                </div>
                <h1 class="text-center">Starten Sie youbuyda</h1>
                <p>Bitte verifizieren Sie ihre Email-Addresse ({{ encodedMail }}) um mit dem Onboarding zu beginnen.</p>
                <p>Klicken Sie hierzu den Link in der Email und Sie werden zum Onboarding weitergeleitet.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VerifyEmail',
    props: {
        email: String,
    },
    computed: {
        encodedMail() {
            return this.email.replace(/^.+@/,'*');
        }
    }
};
</script>